import React from "react";
import { FormProvider, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

const voyageurSchema = yup.object().shape({
  selectedOption: yup.string().required("Sélectionnez le titre est requis."),
  numero_passport: yup.string().required("Numéro de document est requis."),
  prenom: yup.string().required("Prénom est requis."),
  nom: yup.string().required("Nom est requis."),
  email: yup.string().email("Email invalide!").required("Email est requis."),
  telephone: yup.string().required("Numéro de téléphone est requis."),
});
const reservationSchema = yup.object().shape({
  dateDebut: yup.date().required("La date de début du séjour est requise"),
  dateFin: yup.date().required("La date de fin du séjour est requise")
    .min(yup.ref("dateDebut"), "La date de fin doit être postérieure à la date de début"),
  chambres: yup.array().min(1).of(yup.string()).required("Veuillez sélectionner au moins une chambre"),
  nombreChambres: yup.number().required("Le nombre de chambres est requis").positive("Le nombre de chambres doit être positif"),
  statut: yup.string().required("Le statut de réservation est requis"),
  montant: yup.number().required("Le montant du paiement est requis").positive("Le montant doit être positif"),
  paiement: yup.string().required("Le statut du paiement est requis"),
  source: yup.string().required("La source de paiement est requise"),
  nomReservation: yup.string().required("Le nom de la réservation est requis")
});
const combinedSchema = yup.object().shape({
  ...voyageurSchema.fields,
  ...reservationSchema.fields
});

const VoyageurProvider = ({ children }) => {
  const methods = useForm({
    resolver: yupResolver(combinedSchema),
    defaultValues: {
      selectedOption: "",
      numero_passport: "",
      prenom: "",
      nom: "",
      email: "",
      telephone: "",
      dateDebut: "",
      dateFin: "",
      chambres: [],
      nombreChambres: "",
      statut: "",
      montant: "",
      paiement: "",
      source: "",
      nomReservation: ""
    },
  });

  return (
    <FormProvider {...methods}>{ children }</FormProvider>
  );
};

export default VoyageurProvider;